<script>
export default {
  name: 'ItineraryPricesPriceSettingsDiscountModal',
  props: {
    discountPaxes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    setDiscount(index, value) {
      this.discountPaxes[index].discount = +value;
    },
    updateDiscounts() {
      this.$emit('update', this.discountPaxes);
      this.dialog = false;
    },
  },
};
</script>

<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          :disabled="!discountPaxes.length"
          v-on="on"
          color="red lighten-2"
          flat
          small
          fab
        >
          <v-icon>local_offer</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Discounts (%)
        </v-card-title>

        <v-container grid-list-md>
          <v-layout
            v-for="(discountPax, index) in discountPaxes"
            :key="index"
            row
          >
            <v-flex class="pt-3" xs6>
              Age group: {{ discountPax.ageFrom }}-{{ discountPax.ageTo }}
            </v-flex>
            <v-flex xs6>
              <v-text-field
                @input="setDiscount(index, $event)"
                :value="discountPax.discount"
                placeholder="Discount (%)"
                solo
                hide-details
              />
            </v-flex>
          </v-layout>
        </v-container>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn @click="updateDiscounts" color="primary">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesPriceSettingsDiscountModal.vue